import { Moment } from "moment";

export const asyncPerfLog = (asyncAction: string, start: Moment, end: Moment) => {
    console.log(`Async action ${asyncAction} took ${end.diff(start, "ms")} ms`);
};
